<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <div class="popup_video_container relative">
      <transition name="fade" mode="out-in">
        <img
          src="static/instructions-popup-optometry.jpg"
          v-if="!show_video && instructions.show_initial_image"
          ref="main_img"
        />
        <div
          v-if="show_video"
          class="video_container"
          ref="video_container"
          @click.prevent="prevent_close"
        >
          <video-player
            :options="playerOptions"
            :playsinline="true"
            @loadeddata="video_started"
            :style="videoStyle"
            @ended="on_video_ended($event)"
          />
        </div> </transition
      ><transition name="fade" mode="out-in">
        <div class="option-bar" @click="click_close_popup" v-if="can_close">
          <span class="close-link">X</span>
        </div></transition
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "InstructionsVideoPopup",
  data() {
    return {
      timer: null,
      close_timer: null,
      show_video: false,
      can_close: true,
      videoStyle: {
        width: "50vw",
        height: "10vw"
      }
    };
  },
  computed: {
    ...mapState({
      instructions: (state) => state.sections_content.instructions
    }),
    video_popup_class() {
      return "popup";
    },

    video_height_ratio() {
      return this.instructions.height_ratio;
    },
    playerOptions() {
      let sources = [];
      let showControlBar = true;
      if (this.instructions.is_vimeo) {
        sources.push({
          type: "video/vimeo",
          src: this.instructions.src
        });
        showControlBar = false;
      } else {
        if (this.instructions.has_webm) {
          sources.push({
            type: "video/webm",
            src: "static/content/" + this.instructions.src + ".webm"
          });
        }
        if (this.instructions.has_mp4) {
          sources.push({
            type: "video/mp4",
            src: "static/content/" + this.instructions.src + ".mp4"
          });
        }
      }
      return {
        sources: sources,
        controlBar: showControlBar
      };
    }
  },
  methods: {
    click_close_popup(e) {
      e.preventDefault();
      e.stopPropagation();
      this.close_popup(e);
    },
    close_popup(e) {
      console.log("closing this popup!!!");
      if (!this.can_close) return;

      if (this.timer != null) {
        clearTimeout(this.timer);
      }

      //if we're still showing the image, don't close the popup
      //instead, show the video
      if (!this.show_video) {
        this.open_video();
        return;
      }

      //otherwise, just close the popup
      this.$store.dispatch("set_popup_state", "");
      this.$store.dispatch("set_simple_val", {
        name: "instructions_shown",
        val: true
      });
    },

    prevent_close(e) {
      e.stopPropagation();
    },
    onPopupTimeout() {
      this.open_video();
      //this.can_close = true;
    },
    open_video() {
      this.timer = null;
      if (this.instructions.show_initial_image) {
        this.adjust_video_size_from_img();
      }
      this.show_video = true;
      if (!this.instructions.show_initial_image) {
        this.$nextTick(() => {
          this.adjust_video_size();
        });
      }
      setTimeout(
        function () {
          this.$nextTick(() => {
            this.adjust_video_size();
          });
        }.bind(this),
        1000
      );
    },

    onCloseTimer() {
      this.can_close = true;
    },
    adjust_video_size_from_img() {
      if (!this.$refs.main_img) return;
      let videoWidth = this.$refs.main_img.clientWidth;

      this.videoStyle.width = videoWidth + "px";
      this.videoStyle.height =
        Math.round(videoWidth * this.video_height_ratio) + "px";
    },
    adjust_video_size() {
      if (!this.$refs.video_container) return;
      let videoWidth = this.$refs.video_container.clientWidth;

      this.videoStyle.width = videoWidth + "px";
      this.videoStyle.height =
        Math.round(videoWidth * this.video_height_ratio) + "px";
    },
    video_started() {},
    on_video_ended() {
      this.close_popup();
    }
  },
  mounted() {
    if (this.timer != null) clearTimeout(this.timer);
    if (this.close_timer != null) clearTimeout(this.close_timer);

    if (this.instructions.show_initial_image) {
      this.timer = setTimeout(
        function () {
          this.onPopupTimeout();
        }.bind(this),
        3000
      );
    } else {
      this.open_video();
    }
    /*this.close_timer = setTimeout(
      function () {
        this.onCloseTimer();
      }.bind(this),
      4000
    );*/

    window.addEventListener("resize", this.adjust_video_size);
  },
  beforeDestroy() {
    if (this.timer != null) clearTimeout(this.timer);
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;

  background: rgba(0, 44, 107, 0.8);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  cursor: pointer;
}

.popup_video_container {
  align-self: center;
  margin: 0 0;
}
.popup_video_container img {
  height: auto;
  max-width: 90vw;
  max-height: 90vh;
  margin: 0 auto;
}

.popup_video_container .video_container {
  max-width: 1024px;
  width: 90vw;
  cursor: auto;
}

.popup_video_container /deep/ iframe {
  width: 100% !important;
  height: 100% !important;
}

.popup_video_container /deep/ .video-js {
  width: 100% !important;
  height: 100% !important;
}

.popup_video_container /deep/ .video-js video {
  width: 100% !important;
  height: 100% !important;
  max-width: 100vw;
  max-height: none;
  position: relative !important;
}
.internal-video {
  width: 80%;
  margin: 0 auto;
  max-width: 140vh;
}
.popup_video_container .video-player {
  height: 390px;
  width: 100%;
}

.option-bar {
  position: absolute;
  top: 0;
  right: 0;
}
.close-link {
  color: #fff;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 60px;
  height: 60px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  cursor: pointer;
  transform: translate3d(52%, -52%, 0);
}

@media only screen and (max-width: 1110px),
  only screen and (max-height: 460px) {
  .back-bar a {
    width: 30px;
    height: 30px;
    transform: translate3d(40%, -40%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/InstructionsVideoPopup.vue